export default (sectionType, language) =>
  new Promise((resolve, reject) => {
    window.axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section`, {
        type: sectionType,
        language,
      })
      .then(() => resolve())
      .catch((error) => {
        reject(error);
      });
  });
